<template>
  <div class="nav-container">
    <div class="row">
      <div class="nav-text-left">
        <img class="logo" alt="Logo" src="../../public/img/logo--02.png">
        <ul class="menu">
          <li><a href="/cn/home">首页</a></li>
          <li><a href="/cn/company">公司简介</a></li>
          <li><a href="/cn/product">产品展示</a></li>
          <!--<li><a href="/cn/order">在线订购</a></li>-->
          <li><a href="/cn/contact">联系我们</a></li>
        </ul>
      </div>
      <div class="nav-text-right">
        <ul class="menu">
          <li><a href="/en/home">ENGLISH >></a></li>
        </ul>
        <div class="menu-toggle" v-on:click="popupFlag = !popupFlag">
          <div class="bar"></div>
          <div class="bar"></div>
          <div class="bar"></div>
        </div>
        <ul class="menu-popup" v-show="popupFlag">
          <li><a href="/cn/home">首页</a></li>
          <li><a href="/cn/company">公司简介</a></li>
          <li><a href="/cn/product">产品展示</a></li>
          <!--<li><a href="/cn/order">在线订购</a></li>-->
          <li><a href="/cn/contact">联系我们</a></li>
          <li><a href="/en/home">EN >></a></li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'nav-cn',
  data () {
    return {
      popupFlag: false
    }
  }
}
</script>

<style lang="scss">
  .nav-container {
    background-color: rgba(30, 30, 30, .9);
    position: fixed;
    max-width: 1580px;
    left: 0;
    right: 0;
    margin: 0 auto;
    line-height: 24px;
    z-index: 99;
    transition: all .7s ease;
    -webkit-transition: all .7s ease;
    -moz-transition: all .7s ease;

    @media(min-width: 992px) {
      background-color: rgba(30, 30, 30, .4);
      &:hover {
        background-color: rgba(30, 30, 30, .9);
      }
    }

    .row {
      width: 75%;
      height: 60px;
      margin-left: 12.5%;
      margin-right: 12.5%;
      padding-left: 15px;
      padding-right: 15px;
      position: relative;

      .nav-text-left {
        float: left;
        height: 100%;

        .logo {
          float: left;
          max-height: 25px;
          max-width: 100%;
          margin-top: 19px;
        }

        .menu {
          display: none;
          @media(min-width: 992px) {
            margin: 0;
            display: inline-block;
            height: 100%;
          }

          li {
            float: left;
            display: list-item;
            list-style-type: none;
            border-left: 1px solid rgba(255, 255, 255, .1);
            height: 100%;

            &:first-child {
              border-left: none;
            }

            a {
              display: block;
              color: #fff;
              font-weight: 700;
              font-size: 12px;
              line-height: 24px;
              padding: 18px 24px;
              opacity: 0.7;
              text-decoration: none;
            }

          }
        }
      }

      .nav-text-right {
        float: right;
        .menu {
          display: none;
          @media(min-width: 992px){
            margin: 0;
            display: inline-block;
            height: 100%;

            li {
              float: left;
              display: list-item;
              list-style-type: none;
              height: 100%;

              a {
                display: block;
                color: #fff;
                font-weight: 700;
                font-size: 14px;
                padding-top: 18px;
                padding-left: 24px;
                padding-right: 24px;
                opacity: 0.7;
                text-decoration: none;
              }
            }
          }
        }
        .menu-toggle {
          padding-top: 20px;
          width: 65px;
          @media(min-width: 992px) {
            display: none;
          }
          .bar {
            margin: 4px 0;
            width: 25px;
            height: 3px;
            background-color: white;
          }
        }
        .menu-popup {
          padding: 0;
          list-style-type: none;
          text-align: left;
          a {
            color: #fff;
            font-size: 12px;
            font-weight: 700;
            opacity: .7;
            text-decoration-line: none;
          }
        }
      }
    }
  }
</style>
